import { render, staticRenderFns } from "./TestCreateModal.vue?vue&type=template&id=4213555c"
import script from "./TestCreateModal.vue?vue&type=script&lang=js"
export * from "./TestCreateModal.vue?vue&type=script&lang=js"
import style0 from "./TestCreateModal.vue?vue&type=style&index=0&id=4213555c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports